import type { CertificationStatusForm, SignatureWithCertDataRM } from 'ab-requestModels/signature.requestModel';
import type ApproveWorkOrderRM from 'ab-requestModels/workOrder/approveWorkOrder.requestModel';
import type CreateCustomerSignatureForPublicReportsRM from 'ab-requestModels/workOrder/createCustomerSignatureForPublicReports.requestModel';
import type SubmitWorkOrderForReviewRM from 'ab-requestModels/workOrder/submitForReview.requestModel';

import type { WorkOrderReviewLevel } from '@acceligentllc/shared/enums/workOrderReviewStatus';

class SignatureForm {
	fullName: string;
	isSigned?: boolean;
	signatureImage: Nullable<string>;
	digitalSignatureId: Nullable<number>;
	signedAt: string;
	certificationData?: Nullable<CertificationStatusForm>;

	static toSubmitForReviewRM(
		form: SignatureForm,
		reviewLevel: WorkOrderReviewLevel,
		revertOutdated: boolean,
		certificationData?: Nullable<CertificationStatusForm>
	): SubmitWorkOrderForReviewRM {
		return {
			signatureImage: form.signatureImage,
			digitalSignatureId: form.digitalSignatureId,
			signedAt: form.signedAt,
			reviewLevel,
			revertOutdated,
			certificationData: certificationData,
		};
	}

	static toSignatureRM(form: SignatureForm): SignatureWithCertDataRM {
		if (!form.signatureImage) {
			throw new Error('Missing signature image');
		}
		const rm: SignatureWithCertDataRM = {
			signatureImage: form.signatureImage,
			signedAt: form.signedAt,
			certificationData: form.certificationData,
		};
		if (!!form.fullName) {
			rm.fullName = form.fullName;
		}
		return rm;
	}

	static toApproveRM(form: SignatureForm, reviewLevel: Nullable<WorkOrderReviewLevel>, revertOutdated: boolean): ApproveWorkOrderRM {
		return {
			signatureImage: form.signatureImage,
			digitalSignatureId: form.digitalSignatureId,
			signedAt: form.signedAt,
			reviewLevel,
			revertOutdated,
			fullName: form.fullName,
		};
	}

	static toCreateCustomerSignatureRM(form: SignatureForm): CreateCustomerSignatureForPublicReportsRM['signatureData'] {
		if (!form.signatureImage) {
			throw new Error('Missing signature image');
		}
		const rm: CreateCustomerSignatureForPublicReportsRM['signatureData'] = {
			signatureImage: form.signatureImage,
			signedAt: form.signedAt,
			fullName: form.fullName,
		};
		return rm;
	}
}

export default SignatureForm;

